@if (dataSource.data.length === 0 && !loading) {
  <p class="no-data">{{ noDataText }}</p>
} @else {
  <mat-table [dataSource]="dataSource" class="compact-table">
    <ng-container matColumnDef="Project">
      <mat-header-cell *matHeaderCellDef>Project</mat-header-cell>
      <mat-cell *matCellDef="let row">
        @if (row.ProjectNumber || row.ProjectName) {
          <div class="project-cell">
            @if (row.ProjectNumber) {
              <div class="project-number">{{ row.ProjectNumber }}</div>
            }
            @if (row.ProjectName) {
              <div class="project-name">{{ row.ProjectName }}</div>
            }
          </div>
        } @else {
          {{ row.Project || '—' }}
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Name">
      <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
      <mat-cell *matCellDef="let row" class="truncate-cell">{{ row.Name }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Priority">
      <mat-header-cell *matHeaderCellDef>Priority</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="priority-chip {{ row.Priority?.toLowerCase() }}">{{ row.Priority || '—' }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="CreatedOn">
      <mat-header-cell *matHeaderCellDef>Created On</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.CreatedOn | date:'MM/dd/yyyy' }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="DueOn">
      <mat-header-cell *matHeaderCellDef>Due On</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.DueOn | date:'MM/dd/yyyy' }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="DaysOpen">
      <mat-header-cell *matHeaderCellDef>Days Open</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="badge {{ getDaysOpenClass(row.DaysOpen) }}">{{ row.DaysOpen ?? '—' }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="DaysOverdue">
      <mat-header-cell *matHeaderCellDef>Days Overdue</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="badge danger">{{ row.DaysOverdue }}</span>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
}

<mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
